/**
 * Asking the board (pages/DashboardPage.js) to open a project's drawer from anywhere in the portal, as the chat pop-up
 * does (components/Layout.js). The request waits in the tab's sessionStorage under OPEN_PROJECT_KEY, which the board
 * reads whenever it loads its list; OPEN_PROJECT_EVENT tells a board already on screen to load it now. Nothing reloads
 * the page: a reload threw away whatever was being typed in the chat box (a staff request, 2026-11-03).
 */
export const OPEN_PROJECT_KEY = 'ug_open_project';
export const OPEN_PROJECT_EVENT = 'ug-open-project';

export function requestOpenProject(projectId, tab, win = window) {
  try { win.sessionStorage.setItem(OPEN_PROJECT_KEY, JSON.stringify({ projectId, tab })); } catch { /* the board cannot be told */ }
  win.dispatchEvent(new Event(OPEN_PROJECT_EVENT));
}
